// node_modules
import { FC } from "react";
// Types
import { TSideNoteDTO } from "Types";
// Components
import { SideNote } from "./SideNote";
// Enums
import { EntityTypeEnum } from "Enums";
import { HubConstants } from "Constants";

type TSideNoteListProps = {
    sideNotes: TSideNoteDTO[];
    entityType: EntityTypeEnum,
    entityId: number | string,
    isReplyable: boolean,
    extraClassName?: string,
}

export const SideNoteList: FC<TSideNoteListProps> = ({sideNotes, entityType, entityId, isReplyable, extraClassName}: TSideNoteListProps) => {

    return (
        <>
            {sideNotes.map((sideNote) => {
                return (
                    <SideNote 
                        extraClassName={extraClassName} 
                        key={sideNote.id} 
                        sideNote={sideNote} 
                        entityType={entityType} 
                        entityId={entityId} 
                        isReplyable={isReplyable}
                        sideNoteResourceName={`${HubConstants.SIDE_NOTE_RESOURCE_NAME_PREFIX}${sideNote.id}`} />
                );
            })}
        </>
    );
};